import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

//@ts-ignore
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';

export default /*#__PURE__*/_defineComponent({
  __name: 'SubflowUpgradeRequiredBadge',
  setup(__props) {

const showBadge = ref(true);
const billingFeatureId = ref(FeatureTypes.SubFlows);
const closeBadge = () => {
	showBadge.value = false;
};

return { __sfc: true,showBadge, billingFeatureId, closeBadge, MaybeUpgradeRequiredIndicator }
}

})